import Button from "./Buttons/Button";
import Modal from "./Modal";
import styled from "styled-components";

interface ConfirmationModalProps {
  message?: string;
  show?: boolean;
  onCancel?: () => void;
  onConfirm?: () => void;
}

const ConfirmationModal = ({
  message,
  onCancel,
  onConfirm,
  show,
}: ConfirmationModalProps) => {
  return (
    <Modal show={show} onDismiss={onCancel}>
      <Container>
        <div />
        <h5>{message}</h5>
        <ButtonsContainer>
          <Button
            onClick={() => {
              if (onCancel) {
                onCancel();
              }
            }}
            bordered={true}
            size="medium"
            label={"Cancel"}
          />
          <Button
            onClick={() => {
              if (onConfirm) {
                onConfirm();
              }
            }}
            color="green"
            size="medium"
            label={"ok"}
          />
        </ButtonsContainer>
      </Container>
    </Modal>
  );
};

export default ConfirmationModal;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  textarea {
    height: 154px;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
  }
  button {
    width: 100px;
    margin: 10px;
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
`;
